import { Textarea } from '@fsd/ui';
import type { LocalizedString } from '../../types/product';

interface LocalizedTextareaProps {
  label: string;
  value: LocalizedString;
  onChange: (value: LocalizedString) => void;
  lang: 'pt-BR' | 'en-US' | 'es-ES';
  error?: { 'pt-BR'?: string; 'en-US'?: string; 'es-ES'?: string };
  required?: boolean;
  placeholder?: LocalizedString;
  rows?: number;
}

export function LocalizedTextarea({
  label,
  value,
  onChange,
  lang,
  error,
  required,
  placeholder,
  rows = 4,
}: LocalizedTextareaProps) {
  return (
    <div className="space-y-2">
      <span className="text-sm font-medium text-foreground block">
        {label}
        {required && <span className="text-destructive ml-1">*</span>}
      </span>
      <Textarea
        value={value[lang]}
        onChange={(e) =>
          onChange({
            ...value,
            [lang]: e.target.value,
          })
        }
        placeholder={placeholder?.[lang]}
        rows={rows}
        className={error?.[lang] ? 'border-destructive' : ''}
      />
      {error?.[lang] && <p className="text-sm text-destructive mt-1">{error[lang]}</p>}
    </div>
  );
}
